import React from "react";
let closeIcon = new URL("../assets/images/icon-close.svg", import.meta.url);

const ModalFullScreen = ({ title, titleClass, children, onClose }) => {
  let tClasses = "font-internormal text-white uppercase text-[12px]";
  if (titleClass) {
    tClasses = titleClass;
  }

  return (
    <div className="flex flex-col bg-dark-blue fixed w-full h-full z-50">
      <div className="flex items-center p-5">
        <div className="flex flex-grow items-center">
          <div className={`w-full ${tClasses}`}>{title}</div>
        </div>
        <div className="items-center">
          <img
            src={closeIcon}
            alt="close"
            width="22"
            height="22"
            className="h-fit max-w-none cursor-pointer"
            onClick={onClose}
          />
        </div>
      </div>
      <div className="flex-grow p-5 overflow-auto">{children}</div>
    </div>
  );
};

export default ModalFullScreen;
